import * as React from 'react'

import i18n from 'modules/core/lib/i18n'
import type { NavigationRoutesFn } from 'modules/core/lib/react-router'

const DeleteCustomTablePage = React.lazy(
  () => import('modules/custom_resources/pages/DeleteCustomTablePage')
)
const EditCustomTablePage = React.lazy(
  () => import('modules/custom_resources/pages/EditCustomTablePage')
)
const NewCustomTablePage = React.lazy(
  () => import('modules/custom_resources/pages/NewCustomTablePage')
)
const RootPage = React.lazy(() => import('modules/custom_resources/pages/profile/RootPage'))

const profileRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.profile.customTables.path,
      element: <RootPage />,
      handle: {
        meta: () => ({
          title: i18n.t('custom_tables.header'),
        }),
      },
      children: [
        {
          path: navigation.profile.customTables.schemaIdNew.path,
          element: <NewCustomTablePage />,
        },
        {
          path: navigation.profile.customTables.schemaIdValuesValueIdEdit.path,
          element: <EditCustomTablePage />,
        },
        {
          path: navigation.profile.customTables.schemaIdValuesValueIdDelete.path,
          element: <DeleteCustomTablePage />,
        },
      ],
    },
  ]
}

export default profileRoutes
